/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Bell': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" d="M17.522 4.45c2.185 1.27 3.482 3.609 3.375 6.07v1.438a11.153 11.153 0 002.173 6.568l.212.282c.252.327.289.77.093 1.133-.17.316-.488.52-.84.554l-.135.005h-3.954c-.366 2.282-2.223 4-4.446 4s-4.08-1.718-4.446-4H5.611a1.07 1.07 0 01-.986-.56 1.035 1.035 0 01.082-1.117l.404-.566a11.06 11.06 0 001.957-6.264v-1.451c-.106-2.483 1.19-4.822 3.376-6.092a7.064 7.064 0 017.078 0zM17.43 20.5h-6.86c.347 1.733 1.766 3 3.43 3 1.602 0 2.977-1.175 3.387-2.81l.043-.19zM10.946 5.315c-1.865 1.084-2.97 3.074-2.878 5.205v1.473a12.057 12.057 0 01-2.14 6.841l-.418.585a.042.042 0 00-.005.048c.011.02.037.034.086.033H22.41l.047-.004a.065.065 0 00.039-.03c.008-.015.007-.032-.009-.052l-.219-.292a12.158 12.158 0 01-2.37-7.162v-1.462C19.99 8.39 18.886 6.4 17.02 5.315a6.064 6.064 0 00-6.074 0z"/>'
  }
})
